<div class="kb-page" id="dct-avance">
  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title">Aceptación CrediTotal</h1>
      <p class="kb-page-desc">Cuentas domiciliadas en BDV y Mercantil que ya aceptaron los términos de CrediTotal.</p>
    </div>
    <span *ngIf="datos" class="kb-badge kb-badge-contorno">{{ textoInvitacion() }}</span>
  </div>

  <div *ngIf="sinPermiso" class="kb-aviso kb-aviso-info" id="dct-avance-sin-permiso">
    <i class="fas fa-lock"></i><div>No tiene permiso para ver esta pantalla.</div>
  </div>

  <div *ngIf="error" class="kb-aviso kb-aviso-peligro mb-3" id="dct-avance-error">
    <i class="fas fa-exclamation-triangle"></i>
    <div>{{ error }} <button type="button" class="kb-btn kb-btn-outline kb-btn-sm ml-2" (click)="cargar(false)">Reintentar</button></div>
  </div>

  <div *ngIf="(cargando || calculando) && !datos && !sinPermiso && !error" class="kb-hint" id="dct-avance-cargando">
    <i class="fas fa-circle-notch fa-spin"></i> Calculando el avance… puede tardar unos minutos; la página se actualiza sola.
  </div>

  <div *ngIf="vacio" class="kb-empty" id="dct-avance-vacio">
    <div class="kb-empty-titulo">Todavía no hay cuentas por medir</div>
    <div class="kb-empty-texto">No hay cuentas domiciliadas en BDV o Mercantil.</div>
  </div>

  <ng-container *ngIf="datos && !vacio">
    <!-- Avance diario: primero, para ver el ritmo y actuar si se frena -->
    <div class="kb-card mb-3" id="dct-avance-diario">
      <div class="kb-card-header">
        <div class="kb-card-title">Avance diario</div>
        <div class="kb-card-desc">Aceptaciones por día, últimos 30 días · hoy {{ num(ritmo.hoy) }} · ayer {{ num(ritmo.ayer) }} · promedio 7 días {{ num(ritmo.promedio7) }} al día</div>
      </div>
      <div class="kb-card-body">
        <div class="flex items-end gap-0.5 h-24" id="dct-avance-dias">
          <div *ngFor="let d of dias" class="flex-1 h-full flex items-end" [title]="tituloDia(d)">
            <div class="w-full rounded-t" [ngClass]="d.aceptaron ? 'bg-primary/70' : 'bg-muted'" [style.height]="altoBarra(d.aceptaron)"></div>
          </div>
        </div>
        <div class="flex justify-between kb-hint mt-1">
          <span>{{ fechaCorta(dias[0]?.fecha || "") }}</span>
          <span>Hoy</span>
        </div>
      </div>
    </div>

    <!-- Global -->
    <div class="kb-card mb-3">
      <div class="kb-card-body">
        <div class="flex items-end gap-3">
          <div class="text-5xl font-semibold leading-none" id="dct-avance-pct">{{ pct(datos.total?.porcentaje, datos.total?.aceptaron) }}</div>
          <div class="text-sm text-muted-foreground pb-1">
            {{ num(datos.total?.aceptaron) }} de {{ num(datos.total?.universo) }} cuentas · faltan {{ num(datos.total?.faltan) }}
          </div>
        </div>
        <div class="h-2 w-full rounded-full bg-muted mt-3 overflow-hidden">
          <div class="h-2 rounded-full bg-primary" [style.width]="ancho(datos.total?.porcentaje)"></div>
        </div>
        <div *ngIf="datos.piloto" class="kb-hint mt-2" id="dct-avance-piloto">
          Grupo piloto: {{ num(datos.piloto.aceptaron) }} de {{ num(datos.piloto.universo) }} ({{ pct(datos.piloto.porcentaje, datos.piloto.aceptaron) }})
        </div>
      </div>
    </div>

    <!-- Cambio de afiliación: aceptadas a las que el proceso diario todavía no les cambió la afiliación -->
    <div class="kb-card mb-3" id="dct-proceso">
      <div class="kb-card-header">
        <div class="kb-card-title">Cambio de afiliación</div>
        <span *ngIf="pendientes.pendientes > 0" class="kb-badge kb-badge-alerta" id="dct-proceso-chip">Pendientes por correr el proceso</span>
        <span *ngIf="pendientes.pendientes === 0" class="kb-badge kb-badge-exito" id="dct-proceso-chip">Al día</span>
      </div>
      <div class="kb-card-body">
        <div class="flex items-end gap-3 flex-wrap">
          <div class="text-4xl font-semibold leading-none" id="dct-proceso-pendientes">{{ num(pendientes.pendientes) }}</div>
          <div class="text-sm text-muted-foreground pb-1">aceptadas que todavía cobran con la afiliación de Mundo Total</div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
          <div class="rounded-lg bg-muted px-4 py-3">
            <div class="text-2xl font-semibold" id="dct-proceso-sin-afiliacion">{{ num(pendientes.sin_afiliacion_ct) }}</div>
            <div class="text-sm text-muted-foreground">Sin afiliación CrediTotal (paso 1: crear)</div>
          </div>
          <div class="rounded-lg bg-muted px-4 py-3">
            <div class="text-2xl font-semibold" id="dct-proceso-sin-activar">{{ num(pendientes.sin_activar) }}</div>
            <div class="text-sm text-muted-foreground">Con afiliación, sin activar (paso 2: cambiar a CT)</div>
            <div *ngIf="datos.empresa !== 'CT'" class="kb-hint mt-1">Se activan cuando la empresa que cobra sea CrediTotal.</div>
          </div>
        </div>

        <div *ngIf="errorProceso" class="kb-aviso kb-aviso-peligro mt-3" id="dct-proceso-error">
          <i class="fas fa-exclamation-triangle"></i><div>{{ errorProceso }}</div>
        </div>

        <div *ngIf="fase === 'nada'" class="flex items-center justify-end gap-3 mt-3 flex-wrap">
          <span *ngIf="proceso?.corriendo" class="kb-hint"><i class="fas fa-circle-notch fa-spin"></i> {{ proceso.usuario }} está corriendo el proceso…</span>
          <span *ngIf="!proceso?.corriendo && textoUltimaCorrida" class="kb-hint" id="dct-proceso-ultima">{{ textoUltimaCorrida }}</span>
          <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" id="dct-proceso-simular" [disabled]="corriendo" (click)="simular()"
            title="Primero simula y muestra lo que haría; no cambia nada hasta que confirme">
            <i class="fas fa-play"></i> Correr proceso…
          </button>
        </div>

        <div *ngIf="fase === 'simulando' || fase === 'aplicando'" class="kb-hint mt-3" id="dct-proceso-corriendo">
          <i class="fas fa-circle-notch fa-spin"></i>
          {{ fase === 'simulando' ? 'Simulando: contando lo que haría el proceso, sin escribir nada…' : 'Aplicando: creando afiliaciones y cambiando a CrediTotal…' }}
        </div>

        <div *ngIf="fase === 'simulado' && proceso?.resultado as r" class="border-t mt-3 pt-3" id="dct-proceso-simulacion">
          <div class="font-semibold mb-2">Lo que haría el proceso</div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm">
            <div>Afiliaciones CT a crear: <strong>{{ num(r.crear?.creadas) }}</strong></div>
            <div>Personas a cambiar a CT: <strong>{{ r.activar?.omitido ? '— (empresa en Mundo Total)' : num(r.activar?.activadas) }}</strong></div>
            <div>Se omiten: <strong>{{ num(r.activar?.omitidas) }}</strong> <span *ngIf="omisiones(r)" class="text-muted-foreground">({{ omisiones(r) }})</span></div>
          </div>
          <div class="flex flex-col gap-1 mt-3">
            <label class="kb-label" for="dct-proceso-motivo">Motivo (queda en la bitácora de la corrida)</label>
            <textarea class="kb-input" id="dct-proceso-motivo" rows="2" [(ngModel)]="motivo" placeholder="Ej.: cambio de afiliación de las aceptaciones de hoy"></textarea>
          </div>
          <div class="flex justify-end gap-2 mt-3">
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="cancelarProceso()">Cancelar</button>
            <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" id="dct-proceso-aplicar" [disabled]="!motivo.trim()" (click)="aplicar()">Aplicar el cambio</button>
          </div>
        </div>

        <div *ngIf="fase === 'hecho' && proceso?.resultado as r" class="border-t mt-3 pt-3" id="dct-proceso-hecho">
          <span class="kb-badge kb-badge-exito">Listo</span>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm mt-2">
            <div>Creadas: <strong>{{ num(r.crear?.creadas) }}</strong></div>
            <div>Activadas: <strong>{{ num(r.activar?.activadas) }}</strong></div>
            <div>Omitidas: <strong>{{ num(r.activar?.omitidas) }}</strong> <span *ngIf="omisiones(r)" class="text-muted-foreground">({{ omisiones(r) }})</span></div>
          </div>
          <div class="kb-hint mt-2">Las omitidas se reintentan en la próxima corrida. Para revertir: guion 06 con la corrida {{ r.corridas?.[1] || r.corridas?.[0] || '—' }}.</div>
          <div class="flex justify-end mt-2"><button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="cancelarProceso()">Cerrar</button></div>
        </div>
      </div>
    </div>

    <!-- Por banco y producto -->
    <div class="kb-table-envoltorio mb-3">
      <table class="kb-table" id="dct-avance-tabla">
        <thead class="kb-thead">
          <tr>
            <th class="kb-th">Banco</th>
            <th class="kb-th">Producto</th>
            <th class="kb-th kb-th-num">Deben aceptar</th>
            <th class="kb-th kb-th-num">Aceptaron</th>
            <th class="kb-th kb-th-num">%</th>
            <th class="kb-th" style="width: 8rem"></th>
            <th class="kb-th kb-th-num">Faltan</th>
            <th class="kb-th kb-th-num" title="Aceptadas sin afiliación CrediTotal">Por afiliar</th>
            <th class="kb-th kb-th-num" title="Con afiliación CrediTotal, todavía cobrando con Mundo Total">Por activar</th>
          </tr>
        </thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let f of datos.filas">
            <td class="kb-td kb-td-titulo">{{ f.banco || f.bank }}</td>
            <td class="kb-td">{{ producto(f.product_type) }}</td>
            <td class="kb-td kb-td-num">{{ num(f.universo) }}</td>
            <td class="kb-td kb-td-num">{{ num(f.aceptaron) }}</td>
            <td class="kb-td kb-td-num">{{ pct(f.porcentaje, f.aceptaron) }}</td>
            <td class="kb-td">
              <div class="h-1.5 w-full rounded-full bg-muted overflow-hidden"><div class="h-1.5 rounded-full bg-primary" [style.width]="ancho(f.porcentaje)"></div></div>
            </td>
            <td class="kb-td kb-td-num">{{ num(f.faltan) }}</td>
            <td class="kb-td kb-td-num">{{ num(f.sin_afiliacion_ct) }}</td>
            <td class="kb-td kb-td-num">{{ num(f.sin_activar) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-container>

  <div *ngIf="!sinPermiso" class="flex items-center justify-end gap-3 mt-3">
    <span *ngIf="calculando && datos" class="kb-hint"><i class="fas fa-circle-notch fa-spin"></i> Recalculando…</span>
    <span *ngIf="errorExcel" class="kb-hint" id="dct-avance-excel-error" style="color: var(--kb-peligro, #b91c1c)">{{ errorExcel }}</span>
    <button *ngIf="datos" type="button" class="kb-btn kb-btn-outline kb-btn-sm" id="dct-avance-excel" [disabled]="descargando" (click)="descargarExcel()" title="Una fila por cuenta, con quién aceptó y quién falta">
      <i class="fas" [ngClass]="descargando ? 'fa-circle-notch fa-spin' : 'fa-file-excel'"></i> {{ descargando ? 'Preparando…' : 'Descargar Excel' }}
    </button>
    <span *ngIf="datos" class="kb-hint" id="dct-avance-actualizado">{{ textoActualizado }}</span>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="cargando" (click)="cargar(true)">
      <i class="fas fa-sync-alt" [class.fa-spin]="cargando"></i> Actualizar
    </button>
  </div>
</div>
